export enum translationKeys {
	EMAIL_SCREEN_SUBTITLE = "EMAIL_SCREEN_SUBTITLE",
	EMAIL_SCREEN_TITLE = "EMAIL_SCREEN_TITLE",
	FOOTER_BUTTON_LABEL = "FOOTER_BUTTON_LABEL",
  VALID_EMAIL_ADDRESS_MESSAGE = "VALID_EMAIL_ADDRESS_MESSAGE",
  EMAIL_INPUT_PLACEHOLDER = "EMAIL_INPUT_PLACEHOLDER",
  EMAIL_INPUT_LABEL = "EMAIL_INPUT_LABEL",
  PASSWORD_INPUT_PLACEHOLDER = "PASSWORD_INPUT_PLACEHOLDER",
  PASSWORD_INPUT_LABEL = "PASSWORD_INPUT_LABEL",
  PASSWORD_SCREEN_TITLE_NEW = "PASSWORD_SCREEN_TITLE_NEW",
  PASSWORD_SCREEN_TITLE_EXISTING = "PASSWORD_SCREEN_TITLE_EXISTING",
  PASSWORD_SCREEN_PLACEHOLDER_EXISTING = "PASSWORD_SCREEN_PLACEHOLDER_EXISTING",
  PASSWORD_SCREEN_VALIDATION_MESSAGE = "PASSWORD_SCREEN_VALIDATION_MESSAGE",
  PASSWORD_SCREEN_FORGOT_PASSWORD_LABEL = "PASSWORD_SCREEN_FORGOT_PASSWORD_LABEL",
  OTP_SCREEN_TITLE = "OTP_SCREEN_TITLE",
  OTP_SCREEN_SUBTITLE = "OTP_SCREEN_SUBTITLE",
  OTP_SCREEN_FOOTER_BUTTON_LABEL = "OTP_SCREEN_FOOTER_BUTTON_LABEL",
  REGION_SCREEN_TITLE = "REGION_SCREEN_TITLE",
  REGION_SCREEN_SUBTITLE = "REGION_SCREEN_SUBTITLE",
  REGION_SCREEN_FOOTER_BUTTON_LABEL = "REGION_SCREEN_FOOTER_BUTTON_LABEL",
  REGION_SCREEN_COUNTRY_LABEL = "REGION_SCREEN_COUNTRY_LABEL",
  REGION_SCREEN_DISCLAIMER = "REGION_SCREEN_DISCLAIMER",
  PASSWORD_INSTRUCTIONS_LABEL = "PASSWORD_INSTRUCTIONS_LABEL",
  PASSWORD_RULE_MIN_LENGTH = "PASSWORD_RULE_MIN_LENGTH",
  PASSWORD_RULE_ONE_LOWERCASE = "PASSWORD_RULE_ONE_LOWERCASE",
  PASSWORD_RULE_ONE_NUMBER = "PASSWORD_RULE_ONE_NUMBER",
  PASSWORD_RULE_NO_INVALID_SYMBOLS = "PASSWORD_RULE_NO_INVALID_SYMBOLS",
  PASSWORD_RULE_NOT_EMAIL = "PASSWORD_RULE_NOT_EMAIL",
  OTP_SCREEN_RESEND_COUNTDOWN = "OTP_SCREEN_RESEND_COUNTDOWN",
  OTP_SCREEN_RESEND_PROMPT = "OTP_SCREEN_RESEND_PROMPT",
  OTP_SCREEN_RESEND_LABEL = "OTP_SCREEN_RESEND_LABEL",
	CONTACT_WERE_HERE_FOR_YOU = "CONTACT_WERE_HERE_FOR_YOU",
  SAVE_CLOSE_PANEL = "SAVE_CLOSE_PANEL",
	CLOSE = "CLOSE",
  HERE_FOR_YOU = "HERE_FOR_YOU",
  SUPPORT_TEAM_AVAILABILITY_TEXT = "SUPPORT_TEAM_AVAILABILITY_TEXT",
  REGION_SCREEN_COUNTRY_PLACEHOLDER = "REGION_SCREEN_COUNTRY_PLACEHOLDER",
  REGION_SCREEN_COUNTRY_NAMES = "REGION_SCREEN_COUNTRY_NAMES",
  EXISTING_ACCOUNT_MESSAGE = "EXISTING_ACCOUNT_MESSAGE",
  EXISTING_ACCOUNT_TITLE = "EXISTING_ACCOUNT_TITLE",
}
